import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge must know our custom theme keys, or it treats e.g.
// `text-muted` (colour) and `text-sm` (size) as the same group and drops one.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: [
        'bg', 'surface', 'sidebar', 'head', 'fg', 'muted', 'faint', 'line', 'line-strong', 'wash',
        'accent', 'on-accent', 'accent-ink', 'accent-wash', 'blue', 'on-blue', 'pos-ink', 'pos-wash',
        'neg-ink', 'neg-wash', 'warn-ink', 'warn-wash', 'danger-fill', 'on-danger', 'chart', 'chart-2',
        'brand', 'on-brand', 'logo-tile', 'on-tile', 'scrim', 'transparent', 'current',
      ],
      radius: ['ctl', 'card', 'pop', 'thumb', 'pill', 'full'],
      shadow: ['pop', 'panel', 'focus'],
      font: ['sans', 'num', 'mono'],
      text: ['2xs', 'xs', 'sm', 'base', 'lg', 'xl', '2xl'],
      spacing: ['gutter', 'band', 'side', 'rail', 'drawer'],
    },
  },
});

/** Join class names, letting later Tailwind utilities override earlier ones. */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
